<template>
  <div class="recharge-list-container">
    <h1>{{ $t('rechargeList.title') }}</h1>
    
    <!-- 数据加载时显示 -->
    <div v-if="loading" class="loading">{{ $t('common.loading') }}</div>

    <!-- 数据表格 -->
    <table v-else class="recharge-table">
      <thead>
        <tr>
          <th>{{ $t('common.id') }}</th>
          <th>{{ $t('rechargeList.account') }}</th>
          <th>{{ $t('rechargeList.rechargeAmount') }}</th>
          <th>{{ $t('rechargeList.actualAmount') }}</th>
          <th>{{ $t('rechargeList.points') }}</th>
          <th>{{ $t('rechargeList.rechargeTime') }}</th>
          <th>{{ $t('common.status') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(record, index) in records" :key="index">
          <td>{{ record.id }}</td>
          <td>{{ record.zhanghao }}</td>
          <td>{{ record.amount }}</td>
          <td>{{ record.actualAmount }}</td>
          <td>{{ record.points }}</td>
          <td>{{ formatDate(record.payTime) }}</td>
          <td>{{ record.status }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true, // 加载状态
      records: [], // 充值记录数据
    };
  },
  created() {
    this.fetchRechargeRecords();
  },
  methods: {
    // 请求后端获取充值记录
    fetchRechargeRecords() {
      this.$http({
        url: "yonghu/rechargeList",
        method: "get",
      }).then(({ data }) => {
        if (data && data.rechargeList) {
          this.records = data.rechargeList; // 绑定数据到表
        } else {
          console.error(this.$t('rechargeList.dataFormatError'), data);
        }
      }).catch((error) => {
        console.error(this.$t('rechargeList.loadRechargeRecordsFailed'), error);
      }).finally(() => {
        this.loading = false; // 加载完毕，无论成功与否
      });
    },
    // 格式化日期
    formatDate(date) {
      if (!date) return this.$t('rechargeList.noData');
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}:${String(d.getSeconds()).padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.recharge-list-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  border: 1px solid #ddd;
  border-radius: 8px;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}

.loading {
  text-align: center;
  font-size: 16px;
  color: #555;
}

.recharge-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
}

.recharge-table th, .recharge-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.recharge-table th {
  background-color: #f4f4f4;
  font-weight: bold;
}

.recharge-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.recharge-table tr:hover {
  background-color: #f1f1f1;
}
</style>